import { PasswordSetupForm } from '@/components/auth/PasswordSetupForm';

export function PasswordSetup() {
  return <PasswordSetupForm />;
}